export default __webpack_public_path__ + "static/media/healthcare.9dfb2f35.svg";